import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 7.5,
		r: 7,
		stroke: "#086ED6"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 7.5,
		r: 5.5,
		fill: "#086ED6"
	})]
});
export default SvgCircle;
